import { ref, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-710bbaac"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = {
  class: "filter-list-content"
};
const _hoisted_3 = {
  class: "input-select-content"
};
const _hoisted_4 = {
  class: "filter-item"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "产品名称：", -1));
const _hoisted_6 = {
  class: "appListPopover-content"
};
const _hoisted_7 = {
  class: "appListPopover-content-title"
};
const _hoisted_8 = {
  class: "inf-label"
};
const _hoisted_9 = {
  class: "inf-value"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_11 = {
  class: "filter-item"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "推广码信息：", -1));
const _hoisted_13 = {
  class: "filter-item"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "状态：", -1));
const _hoisted_15 = {
  class: "btn-content"
};
import useGetSelect from '@/hooks/useGetSelect';
import { detailFields, searchFields, getAppListInformation, copy } from '@/common';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionFilterBlock',
  emits: ['filterSubmit'],
  setup(__props, {
    emit
  }) {
    const {
      productSelectRef,
      dbtProducts,
      getDbtProducts
    } = useGetSelect();
    const searchForm = ref({
      promotionInfo: '',
      dbtId: undefined,
      promotionStatus: undefined
    });
    const handleSearch = () => {
      const selectedProduct = dbtProducts.value.find(item => item.value === searchForm.value.dbtId);
      emit('filterSubmit', {
        ...searchForm.value,
        productName: (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.label) || ''
      });
    };
    const handleDbtChange = value => {
      searchForm.value.dbtId = value;
      const selectedProduct = dbtProducts.value.find(item => item.value === value);
      emit('filterSubmit', {
        ...searchForm.value,
        productName: (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.label) || ''
      });
    };
    const handleReset = () => {
      searchForm.value = {
        promotionInfo: '',
        dbtId: undefined,
        promotionStatus: undefined
      };
      emit('filterSubmit', {
        ...searchForm.value,
        productName: ''
      });
    };
    onMounted(async () => {
      await getDbtProducts(); // 产品下拉接口
    });
    return (_ctx, _cache) => {
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_unref(ProductSelect), {
        ref_key: "productSelectRef",
        ref: productSelectRef,
        modelValue: searchForm.value.dbtId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchForm.value.dbtId = $event),
        multiple: false,
        "show-extra": true,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": true,
        layout: "vertical",
        descriptionField: "filePath",
        width: 200,
        "popup-class-name": "vertical-product-select",
        placeholder: "请选择",
        detailFields: _unref(detailFields),
        onChange: handleDbtChange,
        "show-bottom-border": ""
      }, {
        detail: _withCtx(({
          detail
        }) => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_SvgIcon, {
          iconClass: "informationIcon",
          class: "informationIcon"
        }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
          return _openBlock(), _createElementBlock("div", {
            key: child.label,
            class: "inf-line"
          }, [_createElementVNode("div", _hoisted_8, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_9, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
            placement: "top"
          }, {
            title: _withCtx(() => [_hoisted_10]),
            default: _withCtx(() => [_createVNode(_component_SvgIcon, {
              iconClass: "copy",
              class: "dbt-copyIcon",
              onClick: $event => _unref(copy)(child.value)
            }, null, 8, ["onClick"])]),
            _: 2
          }, 1024)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue", "search-fields", "detailFields"])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_a_input, {
        value: searchForm.value.promotionInfo,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => searchForm.value.promotionInfo = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入推广码名称/推广码ID",
        style: {
          "width": "200px"
        }
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_a_select, {
        value: searchForm.value.promotionStatus,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => searchForm.value.promotionStatus = $event),
        placeholder: "全部",
        style: {
          "width": "200px"
        },
        allowClear: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_a_select_option, {
          value: ""
        }, {
          default: _withCtx(() => [_createTextVNode("全部")]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "1"
        }, {
          default: _withCtx(() => [_createTextVNode("有效")]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "0"
        }, {
          default: _withCtx(() => [_createTextVNode("失效")]),
          _: 1
        })]),
        _: 1
      }, 8, ["value"])])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_a_button, {
        onClick: handleReset,
        style: {
          "margin-right": "8px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: handleSearch
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});